import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReceiptTypeCodes } from '@checkout-v2/const';
import { DeliveryAddressService, ReceiptService } from '@checkout-v2/feature';
import { UserGeoPointFacade } from '@city/data-access';
import { GeoPoint } from '@core/const';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';
import { DeliveryAddressBlockComponent } from './delivery';
import { SdvorPickupAddressModule } from './pickup/pickup-address.module';

@Component({
  selector: 'sd-receipt-address',
  imports: [SdvorPickupAddressModule, DeliveryAddressBlockComponent, SdvorIconComponent],
  templateUrl: './receipt-address.component.html',
  styleUrls: ['./receipt-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiptAddressComponent {
  private readonly receiptService = inject(ReceiptService);
  private readonly userGeoPointFacade = inject(UserGeoPointFacade);
  private readonly deliveryAddressService = inject(DeliveryAddressService);

  protected readonly active = toSignal(this.receiptService.activeReceiptTypeId$);

  protected readonly receiptTypeCodes = ReceiptTypeCodes;
  protected readonly iconTypes = IconTypes;

  protected readonly addressCityMatches = toSignal(this.deliveryAddressService.addressCityMatches$, {
    initialValue: [],
  });

  setCorrectionCity(point?: GeoPoint): void {
    if (!point) {
      return;
    }
    this.userGeoPointFacade.setGeoPoint(point);
  }
}
